import { Dropdown } from '@wordpress/components';

const UnitsControl = ({ value, onChange, units }) => {
    return (
        <Dropdown
            className="progressmatify-units-dropdown"
            contentClassName="progressmatify-units-content-wrapper"
            position="bottom right"
            renderToggle={({ isOpen, onToggle }) => (
                <button className="progressmatify-selected-unit" onClick={onToggle} aria-expanded={isOpen}>
                    {value}
                </button>
            )}
            renderContent={() => (
                <div className="progressmatify-units-wrapper">
                    {units &&
                        units.map((u, index) => {
                            return (
                                <button
                                    className={`unit-btn ${u === value ? 'progressmatify-active' : ''}`}
                                    key={index}
                                    onClick={() => {
                                        onChange(u);
                                    }}
                                >
                                    {u}
                                </button>
                            );
                        })}
                </div>
            )}
        />
    );
};

export default UnitsControl;
